import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logEventGA4 } from '../../google';
import { migrateReduxSessionStorageFilterValue, sessionStorageMF } from '../../utils';
import { setFilterValue } from '../filterValue';

const initialState = {
  display: 'Intervention Type',
  name: 'trialInterventionType',
  type: 'multiSelect',
  selected: [],
  selectedVal: [],
  options: [
    { value: 'Drug', display: 'Drug' },
    { value: 'Procedure', display: 'Procedure' },
    { value: 'Behavioral', display: 'Behavioral' },
    { value: 'Genetic', display: 'Genetic' },
    { value: 'Device', display: 'Device' },
    { value: 'Diagnostic Test', display: 'Diagnostic Test' },
    { value: 'Radiation', display: 'Radiation' },
    { value: 'Dietary Supplement', display: 'Dietary Supplement' },
    { value: 'Biological', display: 'Biological' },
    { value: 'Other', display: 'Other' },
  ],
};

const storeName = 'trialInterventionType';
export const useTrialInterventionTypeFilter = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        set,
        reset: () => set({ ...initialState }, false, { type: 'reset' }),
        getInitialState: () => ({ ...initialState }),
        setFilterValue: (v) => updateTrialInterventionTypeFilterOption(v),
      }),
      {
        name: `${process.env.NX_APP}-${storeName}`,
        version: 0,
        storage: createJSONStorage(() => sessionStorageMF),
        onRehydrateStorage: () => (state) => {
          migrateReduxSessionStorageFilterValue({ state, key: 'trialInterventionType' });
        },
      },
    ),
    {
      name: `${process.env.NX_APP}`,
      store: storeName,
    },
  ),
);

export const updateTrialInterventionTypeFilterOption = (option) => {
  if (option && process.env.NX_APP === 'MediFind-Pro') {
    const { value } = option;
    logEventGA4('filter', { type: 'trial_intervention', action: 'select', item_id: value }, 'b3623cbd-9b59-4bd1-8929-7496d8b0d3db');
  }
  setFilterValue(useTrialInterventionTypeFilter, option);
};

export const clearTrialInterventionTypeFilterOption = (option) =>
  useTrialInterventionTypeFilter.setState({ ...initialState }, false, {
    type: 'clearTrialInterventionTypeFilterOption',
  });
